import React from 'react';
import styles from '../css/privacy.module.css'

const LocationTerms = () => {

  return (
    <div className={styles.wrapper}>
        {/* 제목 */}
        <h2 className={styles.title}>
          위치기반서비스 이용약관
        </h2>

        {/* 내용 */}
        <div className={styles.contents} style={{whiteSpace: "pre-wrap" }}>
          <div>
            <p><strong>{"제1조 (목적)"}</strong></p>
            <p>
              {"본 약관은 주식회사 로컬(이하 \"회사\")이 제공하는 위치기반서비스(이하 \"서비스\")와 관련하여 회사와 개인위치정보주체(이하 \"이용자\") 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제2조 (용어의 정의)"}</strong></p>
            <p>
              {"① “위치기반서비스”란 회사가 개인위치정보를 이용하여 제공하는 배달대행 플랫폼(배차, 관제, 배송 진행 안내 등) 서비스를 의미합니다.\n"}
              {"② “개인위치정보”란 특정 개인의 위치를 알 수 있는 정보를 의미합니다.\n"}
              {"③ “이용자”란 본 약관에 동의하고 회사가 제공하는 위치기반서비스를 이용하는 자(배달 파트너 및 가맹점 등)를 의미합니다.\n"}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제3조 (약관의 효력 및 변경)"}</strong></p>
            <p>
              {"① 본 약관은 이용자가 본 약관에 동의하고 회사가 정한 절차에 따라 서비스 이용자로 등록함으로써 효력이 발생합니다.\n"}
              {"② 회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n"}
              {"③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 적용일자 7일 전부터 서비스 화면 또는 홈페이지에 공지합니다. 단, 이용자에게 불리한 약관 개정의 경우에는 30일 전부터 공지합니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제4조 (개인위치정보의 수집방법)"}</strong></p>
            <p>
              {"회사는 다음과 같은 방식으로 개인위치정보를 수집합니다.\n"}
              {"\t1. 이용자의 스마트폰 등 단말기 내장 GPS, Wi-Fi, 기지국 기반(Cell ID) 통신 위치정보 수집\n"}
              {"\t2. 서비스 앱 실행 및 백그라운드 상태에서의 주기적인 위치정보 수집"}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제5조 (위치기반서비스의 내용)"}</strong></p>
            <p>
              {"회사는 다음과 같은 위치기반서비스를 제공합니다.\n"}
              {"\t1. "}<strong>{"배차 및 관제 서비스:"}</strong>{"배달기사 위치정보를 이용한 최적 배차 및 동선 관리\n"}
              {"\t2. "}<strong>{"배송 진행 상황 안내:"}</strong>{"가맹점 및 주문 고객에게 픽업 및 배송 진행 상태(현재 위치, 예상 시간 등) 공유\n"}
              {"\t3. 기타 위치정보를 활용한 서비스 운영 및 분쟁 해결"}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제6조 (개인위치정보의 제3자 제공 및 통보)"}</strong></p>
            <p>
              {"① 회사는 원칙적으로 이용자의 사전 동의 없이 개인위치정보를 제3자에게 제공하지 않습니다.\n"}
              {"단, 배달 서비스 이행을 위해 아래와 같이 제공할 수 있습니다."}
            </p>

            <table>
              <thead>
                <tr>
                  <th>제공받는 자</th>
                  <th>제공목적</th>
                  <th>제공 항목</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>가맹점(상점)</td>
                  <td>배송 픽업 및 진행 상황 안내</td>
                  <td>배달 파트너의 현재 위치</td>
                </tr>
                <tr>
                  <td>주문 고객 (수령인)</td>
                  <td>배송 진행 상황 및 도착 안내</td>
                  <td>배달 파트너의 현재 위치</td>
                </tr>
                <tr>
                  <td>외부 주문 연동 플랫폼</td>
                  <td>배달 상태 및 위치 정보 연동</td>
                  <td>배달 파트너의 현재 위치</td>
                </tr>
                <tr>
                  <td>제휴 보험사</td>
                  <td>사고 처리 및 유상운송 보험 청구 사고</td>
                  <td>사고 당시의 위치 정보</td>
                </tr>
              </tbody>
            </table>

            <p>
              {"② 회사는 이용자가 지정하는 제3자에게 개인위치정보를 제공하는 경우, 개인위치정보를 수집한 당해 통신단말장치로 매회 이용자에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.\n"}
              {"다만, 아래 각 호에 해당하는 경우 이용자가 미리 지정한 전자우편, 앱 내 알림 또는 온라인 게시 등의 방법으로 통보할 수 있습니다.\n"}
              {"\t 1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우\n"}
              {"\t 2. 이용자가 온라인 게시 등의 방법으로 통보할 것을 미리 요청하거나 동의한 경우"}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제7조 (개인위치정보의 보유기간 및 파기)"}</strong></p>
            <p>
              {"① 회사는 위치정보 이용 목적 달성 후 개인위치정보를 지체 없이 파기합니다.\n"}
              {"② 단,「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 따른 '위치정보 수집·이용·제공사실 확인자료'는 배송 분쟁 해결 및 고객 CS 대응을 위하여 위치정보시스템에 자동으로 기록하며, 해당 자료는 수집일로부터 6개월간 보관한 후 파기합니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제8조 (개인위치정보주체의 권리 및 행사방법)"}</strong></p>
            <p>
              {"① 이용자는 회사에 대하여 언제든지 개인위치정보의 수집, 이용, 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.\n"}
              {"② 이용자는 회사에 대하여 언제든지 개인위치정보의 수집, 이용, 제공의 일시적인 중지를 요구할 수 있습니다.\n"}
              {"③ 이용자는 회사가 보관 중인 '위치정보 수집·이용·제공사실 확인자료'에 대한 열람 또는 고지를 요구할 수 있고, 오류가 있는 경우 정정을 요구할 수 있습니다.\n"}
              {"④ 이용자는 앱 내 설정 메뉴 또는 고객센터를 통해 제1항 내지 제3항의 권리를 행사할 수 있습니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제9조 (법정대리인 등의 권리)"}</strong></p>
            <p>{"회사는 14세 미만의 이용자에 대해서는 회원가입 및 서비스 이용이 불가합니다."}</p>
            <p>{"\n"}</p>
            <p><strong>{"제10조 (손해배상 및 면책)"}</strong></p>
            <p>
              {"① 회사가 위치정보법 제15조 내지 제26조의 규정을 위반하여 이용자에게 손해가 발생한 경우, 이용자는 회사에 손해배상을 청구할 수 있습니다. 회사는 고의 또는 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.\n"}
              {"② 회사는 천재지변, 기타 불가항력적 사유, 이용자의 귀책사유로 인한 서비스 장애 및 손해에 대하여 책임을 지지 않습니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제11조 (위치정보 관리책임자)"}</strong></p>
            <p>
              {"회사는 개인위치정보 보호를 위해 다음과 같이 위치정보 관리책임자를 지정합니다\n"}
              {"\t•  책임자 성명: 이현우\n"}
              {"\t•  소속/직책: 연구소장\n"}
              {"\t•  연락처: 1800-1321\n"}
              {"\t•  이메일: catchdev0@gmail.com\n"}
              {"\t•  주소: 서울특별시 마포구 월드컵북로 396 (상암동, 누리꿈스퀘어) 1005호\n"}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"제12조 (분쟁 해결)"}</strong></p>
            <p>
              {"본 약관과 관련된 분쟁이 발생할 경우 회사와 이용자는 상호 협의하여 해결하도록 노력하며, 협의가 이루어지지 않을 경우 회사의 본점 소재지를 관할하는 법원을 전속관할로 합니다."}
            </p>
            <p>{"\n"}</p>
            <p><strong>{"부칙"}</strong></p>
            <p>{"본 약관은 2026년 3월 13일부터 시행됩니다."}</p>
          </div>
        </div>
    </div>
  );
}

export default LocationTerms;
